export default __webpack_public_path__ + "static/media/inspectoere-confirm.c62be219.svg";